// Открытие и закрытие бургера
document.querySelector('.burger-icon')?.addEventListener('click', function () {
    document.querySelector('.burger-menu').classList.toggle('active');
    this.classList.toggle('active');
});

// Открытие и закрытие поиска
document.querySelector('.search-icon')?.addEventListener('click', function () {
    const parent_el = this.closest('.container-fluid');
    const search_block_el = parent_el.querySelector('.search-block');

    search_block_el.classList.add('active');
})

document.addEventListener('mouseup', function(e) {
    const searchForm = document.querySelector('.aws-container');

    if (searchForm && !searchForm.contains(e.target)) {
        searchForm.classList.remove('active');
    }
});

document.querySelector('.close-form')?.addEventListener('click', function() {
    document.querySelector('.aws-container').classList.remove('active');
});

// Открытие и закрытие блока с поиском в мобилке
document.querySelectorAll('.search-block .aws-search-field').forEach(function(input) {
    input.addEventListener('focus', function() {
        const searchBlock = this.closest('.search-block');
        if (searchBlock) {
            searchBlock.classList.add('open');
        }
        this.select();
    });
});

document.querySelector('.back-search')?.addEventListener('click', function() {
    const parent_el = this.closest('.search-block');

    parent_el.classList.remove('open');
});

window.addEventListener('scroll', function() {
    const scrollY = window.scrollY || document.documentElement.scrollTop;
    const aboutSearch = document.querySelector('.page-template-about .search-block');
    const indexSearch = document.querySelector('.page-template-index .search-block');

    if (scrollY > 45) {
        aboutSearch?.classList.add('fixed');
        indexSearch?.classList.add('fixed');
    } else {
        aboutSearch?.classList.remove('fixed');
        indexSearch?.classList.remove('fixed');
    }
});

// Показываем блок с поиском в мобилке на Страницах
window.addEventListener('scroll', function() {
    const scrollY = window.scrollY || document.documentElement.scrollTop;
    const selectors = [
        '.page-template-contacts .search-block',
        '.page-template-text .search-block',
        '.archive .search-block',
        '.product-template-default .search-block'
    ];

    selectors.forEach(selector => {
        document.querySelectorAll(selector).forEach(el => {
            el.classList.toggle('fixed', scrollY > 45);
        });
    });
});